// Normalizes G-Solar's single combined invoice (both GSolar Power and VS
// Alpha use this same shape, built by functions/builders/gsolarBuilder.js):
// payroll cost (salary/PPE/EOBI/health insurance/GLI, no tax) plus a taxed
// service-charge line, all on one document — unlike ARSL/Sefam's split into
// two separate invoice numbers.
import { LINE_CATEGORIES, makeLine } from "../lineCategories";

export function normalizeGSolarInvoice(sourceDoc) {
  const employees = sourceDoc.employees || [];
  const salary = employees.reduce((s, e) => s + Number(e.payableSalary || 0), 0);
  const ppe = employees.reduce((s, e) => s + Number(e.ppe || 0), 0);
  const eobi = employees.reduce((s, e) => s + Number(e.eobi || 0), 0);
  const healthInsurance = employees.reduce((s, e) => s + Number(e.healthInsurance || 0), 0);
  const gli = employees.reduce((s, e) => s + Number(e.gli || 0), 0);
  const serviceCharge = Number(sourceDoc.serviceChargeSum || 0);
  const gstAmount = Number(sourceDoc.gst || 0);
  const grossAmount = Number(sourceDoc.grandTotal || 0);

  const lines = [
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "Salary reimbursement", amount: salary, sourceField: "employees.payableSalary" }),
    makeLine({ category: LINE_CATEGORIES.SALARY_REIMBURSEMENT, description: "PPE allowance", amount: ppe, sourceField: "employees.ppe" }),
    makeLine({ category: LINE_CATEGORIES.EOBI_RECOVERY, description: "EOBI recovery", amount: eobi, sourceField: "employees.eobi" }),
    makeLine({ category: LINE_CATEGORIES.INSURANCE_RECOVERY, description: "Health insurance recovery", amount: healthInsurance, sourceField: "employees.healthInsurance" }),
    makeLine({ category: LINE_CATEGORIES.GLI_RECOVERY, description: "GLI recovery", amount: gli, sourceField: "employees.gli" }),
    makeLine({ category: LINE_CATEGORIES.SERVICE_CHARGE, description: "Service charges @ 5%", amount: serviceCharge, sourceField: "serviceChargeSum" }),
    makeLine({ category: LINE_CATEGORIES.GST, description: "Sindh Sales Tax @ 15%", amount: gstAmount, sourceField: "gst" })
  ];

  return { lines, serviceChargeSubtotal: serviceCharge, invoiceAmount: salary + ppe + eobi + healthInsurance + gli, gstAmount, grossAmount, recoveryBase: null, recoveryAddBack: null };
}
